export default {
  atDepth: '{valueUnit} na {depth} {depthUnit}',
  time: 'Czas',
  temp: 'Temperatura',
  nlPerHPerM: 'Przepływ',
  cAtm: 'Atmosfera',
  cnAtm: 'Atmosfera',
  cd: 'płyta CD',
  retainedAustenite: 'ret. aust. ca.',
  hardnessProfile: 'Twardość',
  modal: {
    header: 'Konfiguracja tabeli węglowej',
    depth: 'Głębokość',
  },
};
